export function mountPagination(root = document) {
	root.querySelectorAll("[data-paginate]").forEach((scope) => {
		if (scope.dataset.paginationMounted) return;
		const selector = scope.dataset.paginationSelector || ":scope > *";
		const pageSize = Number.parseInt(scope.dataset.pageSize || "9", 10);
		const items = [...scope.querySelectorAll(selector)];
		if (!items.length || !Number.isFinite(pageSize)) return;

		let page = 1;
		try {
			const urlParams = new URLSearchParams(window.location.search);
			const requestedPage = Number.parseInt(urlParams.get("page") || "1", 10);
			if (Number.isFinite(requestedPage) && requestedPage >= 1) {
				page = requestedPage;
			}
		} catch (e) {
			page = 1;
		}

		const nav = document.createElement("nav");
		nav.className = "solufy-pagination";
		nav.setAttribute("aria-label", "Pagination");

		const render = (shouldScroll = false) => {
			const currentItems = [...scope.querySelectorAll(selector)];
			const available = currentItems.filter((item) => item.dataset.filterHidden !== "true");
			const pages = Math.max(1, Math.ceil(available.length / pageSize));
			page = Math.min(Math.max(1, page), pages);
			const visible = new Set(available.slice((page - 1) * pageSize, page * pageSize));
			currentItems.forEach((item) => {
				const isVisible = visible.has(item);
				item.hidden = !isVisible;
				if (!isVisible) {
					item.setAttribute("hidden", "");
				} else {
					item.removeAttribute("hidden");
				}
			});

			nav.replaceChildren();
			nav.hidden = pages <= 1;
			if (pages <= 1) return;

			const addButton = (label, target, options = {}) => {
				const button = document.createElement("button");
				button.type = "button";
				button.textContent = label;
				button.disabled = options.disabled || false;
				if (options.current) button.setAttribute("aria-current", "page");
				button.addEventListener("click", () => {
					page = target;
					try {
						const url = new URL(window.location);
						if (page > 1) {
							url.searchParams.set("page", page);
						} else {
							url.searchParams.delete("page");
						}
						window.history.pushState({}, "", url);
					} catch (e) {}
					render(true);
				});
				nav.append(button);
			};

			const addEllipsis = () => {
				const span = document.createElement("span");
				span.className = "solufy-pagination__ellipsis";
				span.textContent = "…";
				span.style.cssText = "display: inline-flex; align-items: center; justify-content: center; width: 2rem; color: var(--solufy-ink-soft);";
				nav.append(span);
			};

			addButton("←", page - 1, { disabled: page === 1 });

			if (pages <= 7) {
				for (let number = 1; number <= pages; number += 1) {
					addButton(String(number), number, { current: number === page });
				}
			} else {
				addButton("1", 1, { current: page === 1 });
				if (page > 3) addEllipsis();
				const start = Math.max(2, page - 1);
				const end = Math.min(pages - 1, page + 1);
				for (let number = start; number <= end; number += 1) {
					addButton(String(number), number, { current: number === page });
				}
				if (page < pages - 2) addEllipsis();
				addButton(String(pages), pages, { current: page === pages });
			}

			addButton("→", page + 1, { disabled: page === pages });

			if (shouldScroll) {
				scope.scrollIntoView({ behavior: "smooth", block: "start" });
			}
		};

		const container = scope.querySelector(".solufy-container") || scope;
		container.append(nav);
		scope.addEventListener("solufy:filter", () => { page = 1; render(); });
		scope.dataset.paginationMounted = "true";
		render();
	});
}
